import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useMemo } from "react";
import { generateMenuData } from "../utils/helpers";
import Menu from "../../Menu/Menu";
import Button from "../../Button/Button";
import MoreVerticalIcon from "../../Icon/MoreVertical";
export default function CompactActions(param) {
    var accessibilityLabel = param.accessibilityLabel, actions = param.actions, isRtl = param.isRtl, testID = param.testID;
    var ref = useMemo(function() {
        return generateMenuData(actions, true);
    }, [
        actions
    ]), menuOptions = ref.menuOptions, menuSelectFunction = ref.menuSelectFunction;
    return _jsx(Menu, {
        options: menuOptions,
        testID: testID,
        onSelect: function(selection) {
            return menuSelectFunction(selection);
        },
        trigger: function(handlePress) {
            return _jsx(Button, {
                accessibilityLabel: accessibilityLabel,
                appearance: "ghost",
                variant: "menu",
                icon: MoreVerticalIcon,
                iconAlign: "end",
                onClick: handlePress,
                isRtl: isRtl
            });
        },
        placement: "bottom-end",
        isRtl: isRtl
    });
};
